import { GetObjectItemDischargesQueryDto, ObjectItemDischarge } from '@ekt-group/general-purpose-api-interfaces';
import { useQuery, queryOptions } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { QueryConfig } from '@/lib/react-query';

interface GetObjectItemDischargesParams extends GetObjectItemDischargesQueryDto {
  contractIds?: number[];
}
export const getObjectItemDischarges = async (params: GetObjectItemDischargesParams) => {
  const { data } = await httpService.get<(ObjectItemDischarge & { priceWithVat: string })[]>('/objects/items/discharges', {
    params,
  });
  return data;
};

export const getObjectItemDischargesQueryOptions = (params: GetObjectItemDischargesParams) => {
  return queryOptions({
    queryKey: ['object-item-discharges', params],
    queryFn: () => getObjectItemDischarges(params),
  });
};

type UseObjectItemDischargesOptions = {
  params: GetObjectItemDischargesParams;
  queryConfig?: QueryConfig<typeof getObjectItemDischargesQueryOptions>;
};

export const useGetObjectItemDischarges = ({ params, queryConfig }: UseObjectItemDischargesOptions) => {
  return useQuery({
    ...getObjectItemDischargesQueryOptions(params),
    ...queryConfig,
  });
};
